import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { useMemo as l } from "react";
import { formatEspecifications as U, formatBrazilianPrice as u, formatedMultiply as w } from "../../../utils/changerOrderModal.js";
import { Icons as z } from "../assets/icons.js";
import { isMobile as S } from "../../../constants/index.js";
const H = ({
  similarProduct: d,
  similarProductSelect: r,
  setSimilarProductSelect: v,
  isClubClient: N
}) => {
  const {
    images: t,
    name: m,
    itemId: h,
    sellingPrice: n,
    measurementUnit: y,
    unitMultiplier: b,
    hasDiscount: C,
    listPrice: i,
    isClub: I,
    skuSpecifications: p
  } = d, M = t == null ? void 0 : t[0].imageUrl, o = l(() => 58, []), g = l(
    () => h === (r == null ? void 0 : r.itemId),
    [r]
  ), c = l(() => U(p || []), [p]), {
    discountPorcent: k,
    frontLstPrice: L,
    frontSellingPrice: P,
    frontPriceMultiply: j
  } = l(() => !n || !i ? {} : {
    discountPorcent: Math.round((i - n) / i * 100) * -1,
    frontLstPrice: u(i || 0),
    frontSellingPrice: u(n || 0),
    frontPriceMultiply: w(
      y || "",
      b || 0
    )
  }, [n, i]), x = {
    Vegano: "var(--color-seals-veg)",
    Orgânico: "var(--color-seals-org)",
    "Sem Glúten": "var(--color-seals-gluten-free)",
    "Sem Lactose": "var(--color-seals-lactose-free)",
    "Sem Açúcar": "var(--color-seals-sugar-free)"
  }, f = g ? "var(--color-main)" : "var(--color-grayScale-lightest)";
  return /* @__PURE__ */ s(
    "div",
    {
      className: "similar-product-list-item",
      onClick: () => {
        h !== (r == null ? void 0 : r.itemId) && v(d);
      },
      style: {
        borderColor: f
      },
      children: [
        /* @__PURE__ */ e("div", { style: { width: o, height: o }, children: /* @__PURE__ */ e(
          "img",
          {
            height: o,
            width: o,
            src: M,
            alt: m,
            style: { objectFit: "contain" }
          }
        ) }),
        /* @__PURE__ */ s("div", { className: "infos", children: [
          /* @__PURE__ */ s("div", { className: "description", children: [
            /* @__PURE__ */ e("h4", { className: "product-name", children: m }),
            /* @__PURE__ */ e(
              "span",
              {
                className: "choose-icon",
                style: {
                  backgroundColor: f
                },
                children: g && /* @__PURE__ */ e(z, { iconId: "Check" })
              }
            )
          ] }),
          !!(c != null && c.length) && /* @__PURE__ */ e("div", { className: "seal-container", children: c.map((a) => /* @__PURE__ */ e(
            "span",
            {
              className: "seal",
              style: { backgroundColor: x[a] },
              children: a
            }
          )) }),
          /* @__PURE__ */ s("div", { className: "prices", children: [
            C && /* @__PURE__ */ s("div", { className: "discount", children: [
              /* @__PURE__ */ e("p", { className: "list-price", children: L }),
              /* @__PURE__ */ s("span", { className: "badge", children: [
                k,
                "%"
              ] })
            ] }),
            /* @__PURE__ */ s("p", { className: "sellingPrice", children: [
              P,
              /* @__PURE__ */ e("span", { className: "sellingPrice-multiply", children: j }),
              I && N && /* @__PURE__ */ e("span", { className: "badge", children: "Clube" })
            ] })
          ] })
        ] })
      ]
    }
  );
};
export {
  H as SimilarProductItem
};
